import { useTheme } from "@/components/context/ThemeContext"
import StoreSection from "./StoreSection"
import FeaturedTournaments from "./Tournament/FeaturedTournaments"
import TournamentHero from "./Tournament/TournamentHero"
import TournamentStats from "./Tournament/TournamentStats"
import styles from "./tournament.module.css"
import { useCallback, useEffect, useState } from "react"
import { api } from "@/utils/apiService"

export default function TournamentPage() {
  const {theme} = useTheme();
  const [tournaments, setTournaments] = useState([]);

  const fetchTournaments = useCallback(async () => {
    try {
      const res = await api.get("/tournaments/active?limit=3");

      setTournaments(res.data.data.tournaments);
    } catch (error) {
      console.log("Error Fetching Tournaments ::", error);
    }
  }, []);

  useEffect(() => {
    fetchTournaments();
  }, [fetchTournaments])
  

  return (
    <main className={`${styles.tournamentsContainer} ${theme}`}>
      <TournamentHero />
      <FeaturedTournaments tournaments={tournaments} />
      <TournamentStats />
      <StoreSection />
    </main>
  )
}
